import React, { useState } from 'react';
import Bounce from 'react-reveal/Bounce';
import { Link } from 'react-router-dom';
import Button from '../components/Form/Button';
import GoogleSignIn from '../components/Form/GoogleSignIn';
import TextField from '../components/Form/TextField';
import useAuth from '../hooks/useAuth';

const SignUpScreen = () => {
  const [userInput, setUserInput] = useState({
    name: '',
    email: '',
    password: '',
  });

  const [errors, setErrors] = useState({});
  const { registerUser } = useAuth(); 

  const Inputs = [
    { id: 1, type: "text", placeholder: "Nom complet", value: userInput.name, name: 'name' },
    { id: 2, type: "email", placeholder: "Email", value: userInput.email, name: 'email' },
    { id: 3, type: "password", placeholder: "Mot de passe", value: userInput.password, name: 'password' },
  ];

  const handleChange = (e) => {
    const { value, name } = e.target;
    setUserInput(prev => ({
      ...prev,
      [name]: value,
    }));

    setErrors(prev => ({
      ...prev,
      [name]: '',
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!userInput.name.trim()) newErrors.name = "Le nom complet est requis.";
    if (!userInput.email.trim()) newErrors.email = "L'email est requis.";
    if (!userInput.password.trim()) newErrors.password = "Le mot de passe est requis.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    await registerUser(userInput.email, userInput.password, userInput.name); // ✅ registerUser navigates
  };

  return (
    <main className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-white to-paragaiaLight">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-6xl w-full p-6">
        <Bounce left>
          <div className="flex flex-col justify-center items-center w-full">
            <div className="mb-6">
              <img
                src="/assets/favicon.png"
                alt="Logo Paragaïa"
                className="w-24 h-24 object-contain select-none"
              />
            </div>

            <form className="bg-white w-full max-w-md p-8 rounded-2xl shadow-2xl" onSubmit={handleSubmit}>
              <div className="flex flex-col space-y-6">
                {Inputs.map(input => (
                  <div key={input.id} className="flex flex-col">
                    <TextField
                      type={input.type}
                      placeholder={input.placeholder}
                      value={input.value}
                      name={input.name}
                      onChange={handleChange}
                    />
                    {errors[input.name] && (
                      <p className="text-red-500 text-sm mt-1">{errors[input.name]}</p>
                    )}
                  </div>
                ))}
              </div>

              <Button
                text="Créer un compte"
                className="w-full mt-6 bg-paragaia text-white py-3 rounded-lg hover:bg-paragaiaLight transition poppins"
              />

              <Link to="/signin">
                <p className="text-base text-paragaia text-center my-6 hover:underline poppins">
                  Vous avez déjà un compte ?
                </p>
              </Link>

              <GoogleSignIn text="Créer avec Google" />
            </form>
          </div>
        </Bounce>

        <Bounce right>
          <div className="hidden md:flex flex-col justify-center items-center w-full">
            <img
              className="w-full max-w-md object-contain"
              src="/assets/signup.png"
              alt="Créer un compte"
            />
          </div>
        </Bounce>
      </div>
    </main>
  );
};

export default SignUpScreen;
